export default function ($) {
  $('.js-show-dialog').on('click', function (event) {
    event.preventDefault();

    var target_id = $(this).data('target');
    var dialog = document.getElementById(target_id);
    dialog.showModal();
  });

  $('.js-hide-dialog').on('click', function () {
    var target_id = $(this).parents('dialog').attr('id');
    var dialog = document.getElementById(target_id);
    dialog.close();
  });
}
